// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"buttonPrimary_buttonPrimary__ja+kz","btnDisabled":"buttonPrimary_btnDisabled__mtWlH","thin":"buttonPrimary_thin__jwevm","small":"buttonPrimary_small__stlh-"};